import React, { useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { ja } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";
import "./DetailSearch.css";

registerLocale("ja", ja);

const DateSearchRow = ({ onChange }) => {
  const [isAll, setIsAll] = useState(true);
  const [mode, setMode] = useState("date");
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [pastDays, setPastDays] = useState(0);

  //全ステートをまとめて上位コンポーネントへ渡す
  const emitChange = (updated = {}) => {
    const state = { isAll, mode, dateFrom, dateTo, pastDays, ...updated };
    onChange && onChange(state);
  };

  //「全件」チェック変更時の処理
  const handleAllChange = (checked) => {
    setIsAll(checked);

    if (checked) {
      // reset all
      setDateFrom(null);
      setDateTo(null);
      setPastDays(0);

      emitChange({
        isAll: true,
        dateFrom: null,
        dateTo: null,
        pastDays: 0,
      });
    } else {
      emitChange({ isAll: false });
    }
  };

  // 日付モード切替（日付指定 / 過去日指定）
  const handleModeChange = (value) => {
    setMode(value);

    if (value === "date") {
      // Reset past
      setPastDays(0);

      emitChange({
        mode: value,
        pastDays: 0,
      });
    }

    if (value === "past") {
      // Reset date range
      setDateFrom(null);
      setDateTo(null);

      emitChange({
        mode: value,
        dateFrom: null,
        dateTo: null,
      });
    }
  };

  //日付入力変更（From / To）
  const handleDateChange = (key, value) => {
    if (key === "from") setDateFrom(value);
    if (key === "to") setDateTo(value);
    emitChange({ dateFrom: key === "from" ? value : dateFrom, dateTo: key === "to" ? value : dateTo });
  };

  const handlePastChange = (value) => {
    if (value === "") {
      setPastDays("");
      emitChange({ pastDays: "" });
      return;
    }

    if (value.length > 4) {
      return;
    }

    let n = Number(value);
    if (n > 9999) n = 9999;
    if (n < 0) n = 0;

    setPastDays(n.toString());
    emitChange({ pastDays: n.toString() });
  };

  // 入力制御：全件 or モードによる disable 制御
  const isDateDisabled = isAll || mode !== "date";
  const isPastDisabled = isAll || mode !== "past";

  //土日ハイライト（カレンダー用）
  const highlightWeekends = (date) => {
      const day = date.getDay();
      return day === 0 ? "highlight-sunday" : day === 6 ? "highlight-saturday" : "";
  };
  return (
    <div className="search-field-row_custom">
      <label className="search-field-label">日付</label>

      <div className="date-search-container">
        <div className="date-search-options">
          <div>
            <input
              type="checkbox"
              checked={isAll}
              onChange={(e) => handleAllChange(e.target.checked)}
            />
            全件
          </div>

          <div>
            <input
              type="radio"
              name="dateMode"
              checked={mode === "date"}
              onChange={() => handleModeChange("date")}
              disabled={isAll}
            />
            日付指定
          </div>

          <div>
            <input
              type="radio"
              name="dateMode"
              checked={mode === "past"}
              onChange={() => handleModeChange("past")}
              disabled={isAll}
            />
            過去日指定
          </div>
        </div>

        {/* ---- Date range ---- */}
        <div className="date-range-row mod-form__text calendar">
            <div>
                <DatePicker
                    selected={dateFrom}
                    onChange={(date) => handleDateChange("from", date)}
                    dayClassName={highlightWeekends}
                    locale="ja"
                    dateFormat="yyyy年MM月dd日"
                    className="custom-datepicker date-input"
                    calendarStartDay={1}
                    style={{zIndex: '2'}}
                    renderCustomHeader={({
                      date,
                      changeYear,
                      changeMonth,
                      decreaseMonth,
                      increaseMonth
                    }) => {
                      const currentYear = new Date().getFullYear();
                      const years = Array.from({ length: 30 }, (_, i) => currentYear - i);

                      const months = [
                        "01","02","03","04","05","06",
                        "07","08","09","10","11","12"
                      ];

                      return (
                        <div className="custom-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 8px" }}>
                          
                          {/* Prev button */}
                          <button onClick={(e) => { e.preventDefault(); decreaseMonth(); }}>
                            {"<"}
                          </button>

                          {/* Year + Month display + dropdown */}
                          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                            <div>
                              <select
                                className="year-select"
                                value={date.getFullYear()}
                                onChange={(e) => changeYear(e.target.value)}
                                style={{ padding: "2px 4px" }}
                              >
                                {years.map((y) => (
                                  <option key={y} value={y}>{y}</option>
                                ))}
                              </select>
                              <span>年</span>
                            </div>

                            <div>
                              <select
                                value={date.getMonth()}
                                onChange={(e) => changeMonth(e.target.value)}
                                style={{ padding: "2px 4px" }}
                                className="month-select"
                              >
                                {months.map((m, i) => (
                                  <option key={i} value={i}>{m}</option>
                                ))}
                              </select>
                              <span>月</span>
                            </div>
                          </div>

                          {/* Next button */}
                          <button onClick={(e) => { e.preventDefault(); increaseMonth(); }}>
                            {">"}
                          </button>
                        </div>
                      );
                    }}

                    onKeyDown={(e) => e.preventDefault()}
                    disabled={isDateDisabled}
                />
            </div>

            <span style={{ margin: "0 6px" }}>〜</span>

            <div>
                <DatePicker
                    selected={dateTo}
                    onChange={(date) => handleDateChange("to", date)}
                    dayClassName={highlightWeekends}
                    locale="ja"
                    dateFormat="yyyy年MM月dd日"
                    className="custom-datepicker date-input"
                    calendarStartDay={1}
                    renderCustomHeader={({
                      date,
                      changeYear,
                      changeMonth,
                      decreaseMonth,
                      increaseMonth
                    }) => {
                      const currentYear = new Date().getFullYear();
                      const years = Array.from({ length: 30 }, (_, i) => currentYear - i);

                      const months = [
                        "01","02","03","04","05","06",
                        "07","08","09","10","11","12"
                      ];

                      return (
                        <div className="custom-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 8px" }}>
                          
                          {/* Prev button */}
                          <button onClick={(e) => { e.preventDefault(); decreaseMonth(); }}>
                            {"<"}
                          </button>

                          {/* Year + Month display + dropdown */}
                          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                            <div>
                              <select
                                className="year-select"
                                value={date.getFullYear()}
                                onChange={(e) => changeYear(e.target.value)}
                                style={{ padding: "2px 4px" }}
                              >
                                {years.map((y) => (
                                  <option key={y} value={y}>{y}</option>
                                ))}
                              </select>
                              <span>年</span>
                            </div>

                            <div>
                              <select
                                value={date.getMonth()}
                                onChange={(e) => changeMonth(e.target.value)}
                                style={{ padding: "2px 4px" }}
                                className="month-select"
                              >
                                {months.map((m, i) => (
                                  <option key={i} value={i}>{m}</option>
                                ))}
                              </select>
                              <span>月</span>
                            </div>
                          </div>

                          {/* Next button */}
                          <button onClick={(e) => { e.preventDefault(); increaseMonth(); }}>
                            {">"}
                          </button>
                        </div>
                      );
                    }}
                    onKeyDown={(e) => e.preventDefault()}
                    disabled={isDateDisabled}
                />
            </div>

        </div>


        {/* ---- 過去日指定 ---- */}
        <div className="past-days-row">
          <span>過去</span>
          <input
            type="number"
            value={pastDays}
            min="0"
            max="9999"
            onChange={(e) => handlePastChange(e.target.value)}
            className="past-input"
            disabled={isPastDisabled}
          />
          <span>日以内</span>
        </div>
      </div>
    </div>
  );
};

export default DateSearchRow;
